import { render, staticRenderFns } from "./DisplayPublicationTable.vue?vue&type=template&id=5933fd40&scoped=true&"
import script from "./DisplayPublicationTable.vue?vue&type=script&lang=js&"
export * from "./DisplayPublicationTable.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPublicationTable.vue?vue&type=style&index=0&id=5933fd40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5933fd40",
  null
  
)

export default component.exports